export default class BaseShape {
  area = null;
  googleMaps = null;
  map = null;

  constructor(googleMaps, map) {
    this.googleMaps = googleMaps;
    this.map = map;
  }

  clear() {
    this.area?.setMap(null);
    this.area = null;
  }
}
